// src/utils/formatToLocalTime.js
import { format, fromZonedTime, toZonedTime } from "date-fns-tz";

const EASTERN_TIMEZONE = "America/Toronto";

// Converts Eastern Time to local time, returns string with timezone
export function formatToLocalTime(rawEasternTime, formatPattern = "PPpp zzz") {
  if (!rawEasternTime) return "";

  try {
    const parsedAsET = fromZonedTime(new Date(rawEasternTime), EASTERN_TIMEZONE);
    const userZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localDate = toZonedTime(parsedAsET, userZone);

    return format(localDate, formatPattern, { timeZone: userZone });
  } catch (error) {
    console.error("Time formatting error:", error);
    return rawEasternTime;
  }
}
